var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#f5e0dc",
    d: "M.5 8.51c0 5.25 5.5 6 7.5 6s7.5-.75 7.5-6c0-4-4.5-6-7.5-7-3 1-7.5 3-7.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eba0ac",
    d: "M6.5 10.51h3c-.33.67-.83 1-1.5 1s-1.17-.33-1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cdd6f4",
    d: "M5 8.51a.5.5 0 100-1 .5.5 0 000 1zm6 0a.5.5 0 100-1 .5.5 0 000 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBun);
export default __webpack_public_path__ + "static/media/bun.39d3188fa26519c161fe6dae447d316c.svg";
export { ForwardRef as ReactComponent };